export default __webpack_public_path__ + "static/media/courses-blue.f9903726.svg";